import React from 'react';
import PropTypes from 'prop-types';

import PlainWidget from '../../Widget';
import { ButtonSmall } from '../../Button/index';

export default function Widget({ footer, title, children, toggleEditable, ...otherProps }) {
  return (
    <PlainWidget
      {...otherProps}
      title={title}
      controls={() => (<ButtonSmall icon="pencil" onClick={toggleEditable} />)}
      footer={footer}
    >
      {children}
    </PlainWidget>
  );
}

Widget.defaultProps = {
  footer: null,
};

Widget.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  title: PropTypes.string.isRequired,
  toggleEditable: PropTypes.func.isRequired,
};

Widget.Footer = PlainWidget.Footer;
